import React, { useEffect, useState } from 'react';
import { TextField, Typography } from '@mui/material';
import { FormDialog } from '../ui';

interface StagedProductScrapeDialogProps {
  open: boolean;
  productName?: string;
  sku?: string;
  initialUrl?: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (sourceUrl: string) => void;
}

export const StagedProductScrapeDialog: React.FC<StagedProductScrapeDialogProps> = ({
  open,
  productName,
  sku,
  initialUrl = '',
  loading = false,
  onClose,
  onSubmit,
}) => {
  const [sourceUrl, setSourceUrl] = useState(initialUrl);

  useEffect(() => {
    if (open) setSourceUrl(initialUrl);
  }, [open, initialUrl]);

  const trimmed = sourceUrl.trim();
  const canSubmit = /^https:\/\/\S+/i.test(trimmed);

  return (
    <FormDialog
      open={open}
      title="Scrape this manufacturer page?"
      onClose={onClose}
      onSubmit={() => onSubmit(trimmed)}
      submitLabel="Queue scrape"
      submitDisabled={!canSubmit}
      loading={loading}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Queues a one-page scrape for {sku || 'this SKU'}
        {productName ? ` (${productName})` : ''}. Images and specs merge into
        this staged row when the page is the same product. Better fields already
        on the row are kept. Retailer listings (B&amp;H, Adorama) stay on 3P
        Backfill — paste the manufacturer PDP only.
      </Typography>
      <TextField
        autoFocus
        fullWidth
        size="small"
        label="Manufacturer product page"
        placeholder="https://www.usa.canon.com/shop/p/…"
        value={sourceUrl}
        onChange={(event) => setSourceUrl(event.target.value)}
        disabled={loading}
      />
    </FormDialog>
  );
};
